;
/*!
 * subitotexto.concours.js
 */
(function ( $, window, document, undefined ) {

	"use strict";

	var pluginName = "selectStyle",
		defaults = {
			className: "select_style_ie"
		};

	function Plugin ( element, options ) {
		this.$element = $( element );
		this.settings = $.extend( {}, defaults, options );
		this.init();
	}

	$.extend( Plugin.prototype, {
		init: function () {
			if ( !this.$element.is( 'select' ) ) {
				return;
			}

			/*if(navigator.userAgent.toLowerCase().indexOf("safari") != 0 )
			 {
			 return;
			 }*/

			if ( typeof CSS == "undefined" || typeof CSS.supports !== "function" || !CSS.supports( "(appearance: none) or (-webkit-appearance: none) or (-moz-appearance: none)" ) ) {
				this.$element.wrap( '<span class="' + this.settings.className + '"></span>' );
			}
		}
	} );

	$.fn[ pluginName ] = function ( options ) {
		return this.each( function () {
			if ( !$.data( this, "plugin_" + pluginName ) ) {
				$.data( this, "plugin_" + pluginName, new Plugin( this, options ) );
			}
		} );
	};

})( jqPla, window, document );

SubitoTexto.concours = {
	init      : function () {
		var $ = jqPla,
			_this = SubitoTexto.concours;

		_this.bindEvents();
	}, // init()
	bindEvents: function () {
		var $ = jqPla,
			_this = SubitoTexto.concours;

		$( ".inline" ).colorbox( { inline: true, width: "80%", height: "80%", opacity: 0.8 } );

		/*_this.$segments.find("a.btn_segment").on('click', _this.onClickSegment);
		 $("#container").on("click", "a.video_link", _this.onClickVideoA);
		 _this.$segmentsCategorie.on("click", "li", _this.onClickVideoLi);*/

	}, // bindEvents()

	onClickVideoA: function ( e ) {
		var $ = jqPla,
			_this = SubitoTexto.concours;

		e.preventDefault();
		var title = $( "span.episode_title" ).html() + " - <span>" + $( this ).find( "span.segment_title" ).html() + "<span>";
		_this.onClickVideo( $( this ), title );
	},

	onClickVideoLi: function ( e ) {
		var $ = jqPla,
			_this = SubitoTexto.concours;

		e.preventDefault();
		var title = $( this ).find( "span.episode_title" ).html() + " - <span>" + $( this ).find( "span.segment_title" ).html() + "<span>";
		_this.onClickVideo( $( this ).find( "a.video_link" ), title );
	},

	onClickVideo: function ( $this, title ) {
		var $ = jqPla,
			_this = SubitoTexto.concours;

		var mediaGroup = $this.attr( "data-mediagroup-id" );
		var videolimelight = $this.attr( "data-videolimelight-id" );
		var imgpreview = $this.attr( "data-imgpreview-id" );
		var mediaId = $this.attr( "href" );
		var description = $this.find( "span.segment_description" ).html();
		//var title = $("span.episode_title").html() + " - <span>" + $this.find("span.segment_title").html() + "<span>";

		var strDataVideo = videolimelight != "" ? "{mediaUID:'Limelight_" + videolimelight + "',autoplay:false,posterFrame:'" + imgpreview + "'}" : "";

		var playerhtml = "<p id=\"episode_player\" class=\"videoPlayer\" data-video=\"" + strDataVideo + "\">" +
			"<img src='" + imgpreview + "' id=\"episode_player_poster\" class=\"imgBlockWithBorder\" height=\"540\" width=\"960\" />" +
			"</p>";

		$( "h2.titre_episode" ).html( title );
		$( "div.description_viewer" ).html( description );
		$( "#viewer_player" ).html( playerhtml );

		var videoObj = $( ".videoPlayer" ).attr( 'data-video' );
		if ( videoObj != undefined && videoObj != "" ) {
			eval( 'var mediaUID = ' + videoObj + '.mediaUID;' );
			if ( mediaUID != undefined && mediaUID != "" ) {
				$( ".videoPlayer" ).Tq_VideoPlayer();
			}
		}
		$( 'html,body' ).animate( { scrollTop: $( "#container" ).offset().top }, 500 );
	}
};


SubitoTexto.concours_inscription = {
	init                : function () {
		var $ = jqPla,
			_this = SubitoTexto.concours_inscription;

		_this.$form = $( '#concours_inscription' ).find( 'form' );
		_this.$container = $( '#inscription_form' );

		_this.$form.find( 'select' ).selectStyle();
		_this.$uploadField = _this.$form.find( '.pla-html5input-wrapper' ).find( 'input[type=file]' );
		_this.iMaxUploadSizeInMegs = 2;

		// .Net s'amuse avec les attributs 'name'
		_this.$form.find( '#id_contest' ).attr( 'name', 'id_contest' );


		_this.$siteSlug = _this.$form.find( '#site_slug' );
		_this.siteSlug = _this.$siteSlug.length > 0 && _this.$siteSlug.val() == 'tfo' ? 'tfo' : 'tq';

		_this.$formProvinceSelect = _this.$form.find( '#MainContent_txt_province__' );
		_this.$formProvinceSelect.attr( 'name', 'txt_province' );

		// Disable all except Québec for TQ and All except Qc and Ontario for TFO
		_this.$formProvinceSelect.find( 'option' ).each( function ( i, el ) {
			var $this = $( this ),
				currValue = $this.val(),
				currText = $this.text();

			/*
			 * 8 = Ontatio
			 * 9 = Québec
			 */
			if ( currValue == 9 || ( _this.siteSlug == 'tfo' && currValue == 8) ) {
				// nothing ... just seemed like a simple way to write the condition than to triple-negative
			} else {
				$this.prop( 'disabled', true );
			}
		} );


		_this.bindEvents();
	}, // init()
	bindEvents          : function () {
		var $ = jqPla,
			_this = SubitoTexto.concours_inscription;

		$( ".inline" ).colorbox( { inline: true, width: "80%", height: "80%", opacity: 0.8 } );
		_this.$container.on( 'click', '#concours_envoyer', _this.submit );

		_this.$uploadField.on( 'change', function ( e ) {
			_this.showFileFieldChanges( $( this ), e );
		} )
	}, // bindEvents()
	showFileFieldChanges: function ( $fileField, event ) {
		var $ = jqPla,
			_this = SubitoTexto.concours_inscription;

		var $neighbourFilenameSpan = $fileField.siblings( '.file-path' ),
			fileValues = event.target.files,
			filename = false;

		if ( fileValues ) {
			if ( typeof fileValues[ 0 ] != 'undefined' && fileValues[ 0 ][ 'name' ] != 'undefined' ) {
				filename = fileValues[ 0 ][ 'name' ];
			}
		}

		if ( $neighbourFilenameSpan.length > 0 ) {

			if ( filename ) {
				$neighbourFilenameSpan.html( filename ).addClass( 'file-chosen' ).attr( 'title', filename );
				$fileField.parents( '.pla-html5input-wrapper' ).addClass( 'has-file' );
			}
		}

	},
	// showFileFieldChanges()
	submit              : function ( e ) {
		var $ = jqPla,
			_this = SubitoTexto.concours_inscription,
			$form = $( '#form_inscription' );

		e.preventDefault();

		if ( $form.is( '.working' ) ) {
			return false;
		}

		if ( window.File && window.FileReader && window.FileList && window.Blob ) {

			if ( typeof _this.$uploadField[ 0 ].files != 'undefined' && typeof _this.$uploadField[ 0 ].files[ 0 ] != 'undefined' ) {
				var iFileErrors = 0,
					file = _this.$uploadField[ 0 ].files[ 0 ],
					fsize = file.size,
					ftype = file.type,
					fname = file.name,
					arrSupportedFileTypes = [ 'image/png', 'image/gif', 'image/jpg', 'image/jpeg' ];


				if ( fsize > 1024 * 1024 * _this.iMaxUploadSizeInMegs ) {
					// too big

					_this.$uploadField.after( '<span class="error">La taille maximale de fichier acceptée est de ' + _this.iMaxUploadSizeInMegs + 'Mo</span>' );
					_this.$uploadField.addClass( 'error' );
					iFileErrors++;
				}

				if ( typeof ftype == 'undefined' || $.inArray( ftype, arrSupportedFileTypes ) < 0 ) {

					_this.$uploadField.after( '<span class="error">Ce type de fichier ne semble pas supporté.</span>' );
					_this.$uploadField.addClass( 'error' );

					iFileErrors++;
				}


				if ( iFileErrors > 0 ) {
					return false;
				}

			}
		} else {
			if ( typeof console != 'undefined' && typeof console.error != 'undefined' ) {
				console.error( 'Ce fureteur ne semble pas supporter l\'envoi de fichier' );
			}
			return false;
		}


		$form.addClass( 'working' );
		SubitoTexto.form.clearErrors( $form );
		$.ajax( {
			//     data: $form.serialize(),
			dataType   : 'json',
			type       : 'post',
			data       : new FormData( $form[ 0 ] ),
			processData: false,
			contentType: false,
			url        : CONFIG.inscription_url
		} ).done( function ( _data ) {
			$form.removeClass( 'working' );
			if ( _data.success == 0 ) {
				SubitoTexto.form.addErrors( $form, _data.errors, true );
			}
			else {
				$( '#message_success' ).show();
				$( '#show_form' ).hide();
			}
		} )
			.fail( function ( ajaxError ) {
				console.error( ajaxError );
			} );
	} // submit()
};       // SubitoTexto.concours_inscription


SubitoTexto.concoursVideos = {
	init            : function () {
		var $ = jqPla,
			_this = SubitoTexto.concoursVideos;

		if ( !$( 'body' ).hasClass( 'concours' ) ) {
			return;
		}

		_this.breakpointForMobile = 640;

		_this.$content = $( '#content' );
		_this.$exampleVideoContainer = _this.$content.find( '#video_exemple' );
		_this.$conseilVideoContainer = _this.$content.find( '.section-conseil-players' ).find( '.video-player' );
		_this.$conseilPreviews = _this.$content.find( '.section-conseil-players' ).find( '.conseil-preview' );

		_this.providerMode = _this.$exampleVideoContainer.data( 'video-provider' );

		_this.activeConseilIndex = 0;

		_this.bindEvents();
	},
	bindEvents      : function () {
		var $ = jqPla,
			_this = SubitoTexto.concoursVideos;


		_this.$exampleVideoContainer.one( 'click', function () {
			_this.replaceWithVideo( $( this ) );
		} );

		_this.$conseilVideoContainer.one( 'click.initialVideoContainer', function () {
			_this.replaceWithVideo( $( this ) );
		} );


		_this.$conseilPreviews.on( 'click.conseilVideoSwitch', function ( e ) {
			_this.switchConseils( $( this ) );
		} );

	},
	replaceWithVideo: function ( $container ) {
		var $ = jqPla,
			_this = SubitoTexto.concoursVideos;

		var videoData = $container.attr( 'data-video' );

		//console.log('Replacing', $container, ' with ', videoData );
		if ( videoData ) {

			// Cleanup because TQ's player is bound to a single, specific element
			var $existingFrame = $container.find( '.video-frame' );
			if ( $existingFrame.length > 0 ) {
				$existingFrame.remove();
			}

			$container.html( '' );

			var $newEmptyContainer = $( '<div class="video-frame" />' ).appendTo( $container );
			$newEmptyContainer.attr( 'data-video', videoData );

			if ( _this.providerMode == 'tq' ) {
				$newEmptyContainer.Tq_VideoPlayer();
			} else {
				$newEmptyContainer.addClass( 'video-tfo' );
				SubitoTexto.videoTfo.replaceWithVideo( $newEmptyContainer, videoData );
			}

			$( 'html,body' ).animate( { scrollTop: $container.offset().top - 50 }, 500 );
		}
	},
	switchConseils  : function ( $preview ) {
		var $ = jqPla,
			_this = SubitoTexto.concoursVideos;

		// unbind since it only applies untiol we switch it out
		_this.$conseilVideoContainer.off( 'click.initialVideoContainer' );
		var videoData = $preview.attr( 'data-video' );

		//console.log( 'Going mobile!', $( window ).width(), _this.breakpointForMobile );
		if ( $( window ).width() <= _this.breakpointForMobile ) {
			// mobile
			if ( videoData ) {
				_this.replaceWithVideo( $preview );
				$preview.off( 'click.conseilVideoSwitch' );
			}
		} else {
			// desktop

			if ( videoData ) {
				_this.activeConseilIndex = $preview.index( _this.$conseilPreviews );
				_this.$conseilVideoContainer.attr( 'data-video', videoData );
				_this.$conseilVideoContainer.data( 'video', videoData );
				_this.replaceWithVideo( _this.$conseilVideoContainer );

				_this.$conseilPreviews.not( $preview ).removeClass( 'active' );
				$preview.addClass( 'active' );
			}
		}
	}
}; // SubitoTexto.concours_videos